<template>
  <div class="cart_content">
   

  </div>
  <tabbar :active="2" />
</template> 
<script >
import tabbar from "../../components/tabbars/tabbar.vue";
import axios from "../../commons/AxiosMethod.js";

export default {
  data() {
    return {
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
    };
  },
  name: "App",
  mounted() {},
  components: {
    tabbar,
  },
  methods: {
    tabSwitch(item, index) {
      console.log(item, index);
    },
  },
};
</script>
 
 
<style lang="scss" scoped>
 
</style>
